import type { MissionTaskType } from '@tryhackme/interfaces';
import { TempCustomNotificationDispatch } from '@tryhackme/thm-ui-components';
import { useEffect } from 'react';
import { addSocketListener, emitSocketEvent, removeSocketListener } from 'src/common/sockets';
import { MissionProgressNotification } from 'src/features/dashboard/components/missions/notifications';
import openMissionChest from 'src/images/pngs/dashboard/open-mission-chest.png';
import partiallyOpenMissionChest from 'src/images/pngs/dashboard/partial-mission-chest.png';
import type { TicketType } from './ticketing/ticketing.types';
const MISSION_JOIN_EVENT = 'mission-join';
interface MissionProgressEvent {
  taskType: MissionTaskType;
  currentProgress: number;
  targetProgress: number;
  taskName: string;
  timestamp: string;
}
export interface TicketResult {
  readonly type: TicketType;
  readonly drawOrder: number;
}
export interface TicketResult {
  readonly type: TicketType;
  readonly drawOrder: number;
}
export const MissionSocketManager = () => {
  useEffect(() => {
    // Join mission room on connect and reconnect
    const joinMissionRoom = () => {
      emitSocketEvent(MISSION_JOIN_EVENT, {});
    };
    addSocketListener<Record<string, unknown>, void>('connect', joinMissionRoom);
    addSocketListener<Record<string, unknown>, void>('reconnect', joinMissionRoom);

    // Join mission room immediately
    emitSocketEvent(MISSION_JOIN_EVENT, {});
    return () => {
      removeSocketListener('connect');
      removeSocketListener('reconnect');
    };
  }, []);
  useEffect(() => {
    const handleMissionProgress = (data: MissionProgressEvent) => {
      // Display the mission progress notification
      const taskName = data.taskName || 'Mission Progress';
      const progressText = `${data.currentProgress}/${data.targetProgress}`;
      const isTaskCompleted = data.currentProgress >= data.targetProgress;
      const missionImage = isTaskCompleted ? openMissionChest : partiallyOpenMissionChest;
      TempCustomNotificationDispatch({
        children: <MissionProgressNotification taskName={taskName} progressText={progressText} isTaskCompleted={isTaskCompleted} />,
        options: {
          className: 'mission-progress-toast',
          icon: <img src={missionImage} alt="Weekly Mission" width={64} height={64} />,
          autoClose: 3000,
          style: {
            borderRadius: '5px',
            padding: '8px',
            maxWidth: '450px'
          }
        }
      });
    };
    addSocketListener('mission-progress', handleMissionProgress);
    return () => {
      removeSocketListener('mission-progress');
    };
  }, []);
  useEffect(() => {
    const handleTicketAwarded = (data: TicketResult) => {
      const ticketType = data.type.charAt(0).toUpperCase() + data.type.slice(1); // Capitalize first letter

      TempCustomNotificationDispatch({
        children: `🎫 You won a ${ticketType} ticket!`,
        options: {
          className: 'ticket-awarded-toast',
          autoClose: 40000
        }
      });
    };
    addSocketListener('ticket-awarded', handleTicketAwarded);
    return () => {
      removeSocketListener('ticket-awarded');
    };
  }, []);
  return null;
};